import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DATA } from "../data/newsletterData";

function Cover() {
  const [imageWidth, setImageWidth] = useState();

  useEffect(() => {
    setImageWidth(document.querySelector("img#actualCover").offsetWidth);
  }, []);

  const Text = styled.p`
    width: ${imageWidth};
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40%;
    color: rgba(0, 0, 0, 0.9);
    font-size: var(--big-text);
    font-weight: 700;
  `;

  return (
    <Container>
      <img src="/cover.webp" id="actualCover" alt="" className="cover" />
      <Text>Now we are in week - {DATA.length - 1} </Text>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  position: relative;
  img {
    height: auto;
    width: min(395.875px, 100%);
    margin: 0 auto;
  }
`;

export default Cover;
